<template>
  <div class>
    <div class="row mt-4">
      <div class="flex md2 mb-2">
        <va-button small color="info" @click="showCampaignRemove = true"
          >Gestion des campagnes</va-button
        >
      </div>
      <div class="flex md2 mb-2">
        <va-button small color="info" @click="showAdhesionsLiees = true"
          >Adhésions liées</va-button
        >
      </div>
      <div class="flex md12">
        <div class="row">
          <div class="flex md1">
            <va-button color="info" @click="createNew" icon="fa fa-plus" />
          </div>
          <div class="flex md11">
            <h4 class="fullwidth" style="position: relative; top: 0.5em">
              Ajouter une période d'adhésion
            </h4>
          </div>
        </div>
        <div class="row">
          <div class="flex md12" v-if="adhesionsList.length < 1">
            <p class="text--secondary">Aucune adhésion</p>
          </div>
        </div>
        <div class="row">
          <div
            class="row mt-1 clickable container-comments"
            :style="'max-height: 100%'"
          >
            <template v-for="adhesions in adhesionsList">
              <div
                class="row px-2 pt-2 fullwidth"
                @click="updateAdhesion(adhesions)"
              >
                <div class="flex md2">
                  <p>
                    Du {{ formatDate(adhesions.date_adhesion) }} au
                    {{
                      adhesions.date_fin
                        ? formatDate(adhesions.date_fin)
                        : formatDate(addYear(adhesions.date_renouvellement))
                    }}
                  </p>
                </div>
                <div class="flex md1 test">
                  <p>Adhérent {{ adhesions.nom_court }}</p>
                </div>
                <div class="flex md1 test">
                  <p>{{ cotisationText(adhesions.montant) }}</p>
                  <p class="text--secondary">
                    {{ paiementStatuts(adhesions) }}
                  </p>
                </div>
                <div class="flex md2 test">
                  <p>{{ adhesions.usernameverif }}</p>
                </div>
                <div class="flex md3 test">
                  <p>{{ adhesions.comment }}</p>
                </div>
                <div class="flex md2 test">
                  <va-toggle
                    small
                    v-model="adhesions.mapa"
                    label="Protection juridique MAPA"
                  />
                  <p class="text--secondary text--mapa" v-if="adhesions.mapa">
                    Montant:
                    {{ adhesions.montant_mapa ? adhesions.montant_mapa : 0 }} €
                  </p>
                </div>
                <div class="flex md1 test">
                  <va-button
                    flat
                    :color="adhesions.bulletinColor"
                    icon="fa fa-id-card-o"
                    @click="openbulletin(adhesions)"
                  />

                  <va-button
                    flat
                    :color="adhesions.recuColor"
                    :disabled="
                      ((adhesions.idpaiement_type === 5 ||
                        adhesions.idpaiement_type === 6) &&
                        !adhesions.prelevement) ||
                        !adhesions.date_paiement
                    "
                    icon="fa fa-bookmark"
                    @click="openrecu(adhesions)"
                  />
                </div>
                <div
                  class="flex md12"
                  v-show="adhesions.selectPaiement.id !== 1"
                >
                  <p>
                    Paiement par
                    <b>{{ adhesions.selectPaiement.description }}</b>
                  </p>
                </div>

                <div class="flex md12 row-separator" />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <va-modal
      :title="editTitle"
      class="modal"
      large
      v-model="showEditor"
      cancelClass="none"
      :okText="$t('ficheEntreprise.close')"
      cancelText="Annuler"
      v-on:ok="saveAdhesion"
      v-on:cancel="closeModal"
      noEscDismiss
    >
      <div class="row">
        <div class="flex md8">
          <p class="mb-2">
            {{
              activeAdhesion.usernameverif
                ? "Créé par " + activeAdhesion.usernameverif
                : ""
            }}
          </p>
        </div>
        <div class="flex md4">
          <p class="mb-2 warning--text" v-show="showwarning">
            Attention: ancien format de donnée
          </p>
        </div>

        <div class="flex md12 mb-2">
          <div class="row">
            <div class="flex md2 pl-1 mb-2">
              <va-radio-button
                v-model="activeAdhesion.nom_court"
                option="UNPF"
                label="UNPF"
              />
            </div>
            <div class="flex md2">
              <va-radio-button
                v-model="activeAdhesion.nom_court"
                option="SPEF"
                label="SPEF"
              />
            </div>
            <div class="flex md4">
              <p class="warning--text" v-show="warningSyndicat">
                Veuillez choisir une option
              </p>
            </div>
          </div>
          <div class="row">
            <div class="flex md5">
              <va-toggle
                small
                v-model="activeAdhesion.mapa"
                label="Protection juridique MAPA"
              />
            </div>
            <div class="flex md2">
              <va-input
                v-show="activeAdhesion.mapa"
                v-model="activeAdhesion.montant_mapa"
                placeholder="Montant MAPA"
                label="Montant MAPA"
              />
            </div>
          </div>
        </div>
        <div class="flex md12 mb-2">
          <div class="row">
            <div class="flex md3 pr-2">
              <va-date-picker
                label="Date de début"
                v-model="activeAdhesion.date_adhesion"
                :error="warningDateDebut"
              />
            </div>
            <div class="flex md3 pl-2">
              <va-date-picker
                label="Date de fin"
                disabled
                v-model="activeAdhesion.date_fin"
                :error="warningDateFin"
              />
            </div>
            <div class="flex offset--md1 md5">
              <va-select
                label="Mode de paiement"
                v-model="activeAdhesion.selectPaiement"
                textBy="description"
                :options="paiementOptions"
                no-clear
              />
            </div>
          </div>
        </div>

        <div class="flex md12 mb-2">
          <div class="row">
            <div class="flex md3 pr-2">
              <va-input
                :disabled="
                  activeAdhesion.selectPaiement &&
                    activeAdhesion.selectPaiement.id === 7
                "
                v-model="activeAdhesion.montant"
                placeholder="Montant cotisation"
                label="Montant cotisation"
              />
            </div>
            <div class="flex md3 pl-2">
              <va-date-picker
                label="Date de paiement"
                v-model="activeAdhesion.date_paiement"
              />
            </div>
            <div
              class="flex offset--md1 md5"
              v-if="
                (activeAdhesion.selectPaiement.id === 5 ||
                  activeAdhesion.selectPaiement.id === 6) &&
                  canEndPrelevement
              "
            >
              <div class="row row-inside">
                <div class="flex md9">
                  <va-date-picker
                    :config="{ dateFormat: 'd-m-Y' }"
                    label="Date de fin prelevement"
                    v-model="renouvellement_fin"
                  />
                </div>
                <div class="flex md3">
                  <va-button
                    flat
                    icon="fa fa-close"
                    @click="renouvellement_fin = null"
                  />
                </div>
              </div>
            </div>
            <div
              class="flex offset--md1 md5"
              v-if="
                activeAdhesion.selectPaiement.id !== 5 &&
                  activeAdhesion.selectPaiement.id !== 6
              "
            >
              <div class="row row-inside">
                <div class="flex md12">
                  <va-toggle
                    small
                    :disable="
                      !this.$store.getters.user.renouvellements ||
                        activeAdhesion.renewed ||
                        moment(activeAdhesion.date_fin).isSameOrBefore(moment())
                    "
                    v-model="activeAdhesion.recurrente"
                    label="Renouvellement automatique 2"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex md12">
          <va-input
            v-model="activeAdhesion.comment"
            label="Commentaire:"
            type="textarea"
            autosize
            :minRows="4"
            :maxRows="4"
          />
        </div>
        <div class="flex md6">
          <va-button
            v-if="isAdmin"
            v-show="activeAdhesion.idadhesion"
            class="offset-delete fullwidth"
            color="danger"
            @click="showConfirmDelete = true"
            >Supprimer cette adhésion</va-button
          >
        </div>
      </div>
    </va-modal>
    <va-modal
      class="modal"
      title="Confirmer la suppression"
      v-model="showConfirmDelete"
      message="Voulez vous vraiment supprimer cette adhésion?"
      cancelClass="none"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="deleteAdhesion()"
    />
    <bulletins-adhesions-manager
      v-model="showBulletin"
      :idadhesion="idadhesion"
      :entrepriseName="entrepriseName"
      v-on:uploaded="changeColorBulletin('success')"
      v-on:deleted="changeColorBulletin('info')"
    />
    <recu-manager
      title="Reçu d'adhésion"
      :idadhesion="idadhesion"
      v-model="showRecu"
      v-on:ok="loadAdhesion(identreprise)"
    ></recu-manager>
    <remove-from-campaign
      v-model="showCampaignRemove"
      :identreprise="identreprise"
      :nomEntreprise="entrepriseName"
    />
    <adhesions-liees
      v-model="showAdhesionsLiees"
      :identreprise="identreprise"
      @updateList="loadAdhesion(identreprise)"
    />
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, find, findIndex } from "lodash";
import BulletinsAdhesionsManager from "../components/BulletinsAdhesionsManager";
import RecuManager from "../components/RecuManager";
import moment from "moment";
import RemoveFromCampaign from "../../campaigns/RemoveFromCampaign";
import AdhesionsLiees from "./AdhesionsLiees";

export default {
  name: "adhesionManager",
  props: ["identreprise", "setheight", "entrepriseName"],
  components: {
    AdhesionsLiees,
    BulletinsAdhesionsManager,
    RecuManager,
    RemoveFromCampaign
  },
  data() {
    return {
      moment: moment,
      showAdhesionsLiees: false,
      //TODO a preciser
      isAdmin:
        this.$store.getters.user.droits &&
        this.$store.getters.user.droits === "ADMIN",
      canEndPrelevement: this.$store.getters.user.prelevements,
      showCampaignRemove: false,
      showConfirmDelete: false,
      editTitle: "Editer l'adhésion",
      showEditor: false,
      adhesionsList: [],
      activeAdhesion: this.resetactiveAdhesion(),
      dateNotSet: false,
      warningDateFin: false,
      warningSyndicat: false,
      warningDateDebut: false,
      showwarning: false,
      isNew: false,
      showBulletin: false,
      showRecu: false,
      idadhesion: null,
      renouvellement_fin: null,
      renouvellement_fin_back: null,

      defaultPrice: 180,
      paiementOptions: [
        {
          id: 2,
          description: "Chèque - 1 versement annuel"
        },
        {
          id: 3,
          description: "Virement - 1 versement annuel"
        },
        {
          id: 4,
          description: "Espèces - 1 versement annuel"
        },
        {
          id: 5,
          description: "Prélèvement - 1 prélèvement annuel"
        },
        {
          id: 6,
          description: "Prélèvements - 4 prélèvements annuel"
        },
        {
          id: 7,
          description: "Adhésion offerte"
        }
      ]
    };
  },
  mounted() {},
  methods: {
    cotisationText(cotisation) {
      if (cotisation === 0 || cotisation === "0") {
        return "Cotisation offerte";
      } else if (cotisation) {
        return "Cotisation " + cotisation + "€";
      } else {
        return "-";
      }
    },
    changeColorBulletin(color) {
      let index = findIndex(this.adhesionsList, {
        idadhesion: this.idadhesion
      });
      this.adhesionsList[index].bulletinColor = color;
    },
    paiementStatuts(adhesion) {
      if (adhesion.montant === 0 || adhesion.montant === "0") {
        return adhesion.date_paiement
          ? "Le " + this.formatDate(adhesion.date_paiement)
          : "En attente de paiement";
      } else if (!adhesion.montant) {
        return "";
      } else {
        return adhesion.date_paiement
          ? "Payé le " + this.formatDate(adhesion.date_paiement)
          : "En attente de paiement";
      }
    },
    formatDate(date) {
      let tmp = date.split("-");
      return tmp[2] + "-" + tmp[1] + "-" + tmp[0];
    },
    addYear(date) {
      return moment(date)
        .add(1, "years")
        .format("YYYY-MM-DD");
    },
    createNew() {
      this.activeAdhesion = this.resetactiveAdhesion();
      this.activeAdhesion.montant = this.defaultPrice;
      this.editTitle = "Ajouter une adhésion";
      this.showEditor = true;
      this.isNew = true;
    },
    openbulletin(adhesion) {
      this.idadhesion = adhesion.idadhesion;

      this.showBulletin = true;
    },
    openrecu(adhesion) {
      this.idadhesion = adhesion.idadhesion;
      console.log(adhesion);
      this.showRecu = true;
    },
    updateAdhesion(adhesion) {
      if (!this.showBulletin && !this.showRecu) {
        this.showwarning = false;
        this.activeAdhesion = cloneDeep(adhesion);
        if (!this.activeAdhesion.date_fin) {
          this.showwarning = true;
          this.activeAdhesion.date_fin = this.addYear(
            this.activeAdhesion.date_renouvellement
          );
        }
        this.editTitle = "Modifier l'adhésion";
        this.renouvellement_fin = this.activeAdhesion.renouvellement_fin
          ? moment(this.activeAdhesion.renouvellement_fin).format("DD-MM-YYYY")
          : null;
        this.renouvellement_fin_back = this.renouvellement_fin;
        this.showEditor = true;
      }
    },
    async deleteAdhesion() {
      if (this.activeAdhesion.idadhesion) {
        try {
          let adhesiontodelete = cloneDeep(this.activeAdhesion);
          await axios.delete("/api/adhesion-delete", {
            data: adhesiontodelete
          });
          let index = findIndex(this.adhesionsList, {
            idadhesion: this.activeAdhesion.idadhesion
          });
          this.adhesionsList.splice(index, 1);
          this.activeAdhesion = this.resetactiveAdhesion();
          this.launchEpicmaxToast("Adhésion supprimée");
          this.showEditor = false;
          this.$emit("adhesionschange", true);
        } catch (err) {
          if (err.response.status === 400) {
            this.launchEpicmaxToast(err.response.data);
          } else {
            console.log(err);
            this.launchEpicmaxToast(
              "Erreur lors de la suppression de l'adhésion"
            );
          }
        }
      } else {
        this.launchEpicmaxToast("L'adhésion n'est pas sauvegardée");
      }
    },
    convertDate(date) {
      let t = date.split("-");
      return t[2] + "-" + t[1] + "-" + t[0];
    },
    async loadAdhesion(identreprise) {
      try {
        let rlist = await axios.get("/api/adhesions-list-entreprise", {
          params: {
            id: identreprise
          }
        });

        this.adhesionsList = rlist.data;
        this.adhesionsList.forEach(element => {
          console.log("adh test", element);
          element.mapa = element.mapa ? true : false;
          element.recurrente = element.recurrente ? true : false;
          element.initMapa = element.mapa;
          element.bulletinColor = element.pdfdisponible ? "success" : "info";
          element.recuColor = element.nbRecu > 0 ? "success" : "info";
          console.log("idpaiement_type", element.idpaiement_type);
          if (element.idpaiement_type === 1 || !element.idpaiement) {
            element.selectPaiement = {
              id: 1,
              description: "inconnu"
            };
          } else {
            element.selectPaiement = find(this.paiementOptions, [
              "id",
              element.idpaiement_type
            ]);
          }
          console.log("adh test", element);
        });
      } catch (error) {
        console.log(error);
      }
    },
    resetactiveAdhesion() {
      this.isNew = false;
      this.showwarning = false;
      this.warningDateFin = false;
      this.warningSyndicat = false;
      this.warningDateDebut = false;
      this.renouvellement_fin = null;
      this.renouvellement_fin_back = null;

      let newdate = moment().format("YYYY-MM-DD");

      return {
        idadhesion: null,
        entreprise_identreprise: this.identreprise,
        comment: null,
        idutilisateur: this.$store.getters.user.idutilisateurs,
        date_adhesion: newdate,
        date_fin: this.addYear(newdate),
        nom_court: null,
        usernameverif:
          this.$store.getters.user.prenom + " " + this.$store.getters.user.nom,
        syndicat_idsyndicat: null,
        montant: null,
        date_paiement: null,
        date_facturation: newdate,
        idpaiement_type: 1,
        recurrente: false,
        mapa: false,
        selectPaiement: {
          id: 1,
          description: "inconnu"
        },
        montant_mapa: null,
        renouvellement_fin: null,
        renouvellement_fin_back: null
      };
    },
    async saveAdhesion() {
      this.showEditor = true;
      // check if a prelevement exist
      //moving the block at the level of the backend
      // if (this.activeAdhesion.prelevement > 0) {
      //   this.launchEpicmaxToast(
      //     "Un prélèvement est relié à cette adhésion. Modifications bloquées"
      //   );
      //   return;
      // }

      // check that the mandatory fields are set
      let notvalid = false;

      if (!this.activeAdhesion.nom_court) {
        this.warningSyndicat = true;
        notvalid = true;
      }

      if (!this.activeAdhesion.date_adhesion) {
        this.warningDateDebut = true;
        notvalid = true;
      }

      if (!this.activeAdhesion.date_fin) {
        this.warningDateFin = true;
        notvalid = true;
      }

      if (notvalid) {
        return;
      }

      this.activeAdhesion.idpaiement_type = this.activeAdhesion.selectPaiement.id;
      // if (
      //   this.activeAdhesion.idpaiement_type !== 5 &&
      //   this.activeAdhesion.idpaiement_type !== 6
      // ) {
      //   this.activeAdhesion.recurrente = false;
      // }

      // add information if need to end prelevements

      this.activeAdhesion.renouvellement_fin = this.renouvellement_fin
        ? moment(this.renouvellement_fin, "DD-MM-YYYY").format("YYYY-MM-DD")
        : null;

      try {
        //update or create
        let commentres = await axios.post(
          "/api/update-adhesion",
          this.activeAdhesion
        );
        this.loadAdhesion(this.identreprise);
        this.launchEpicmaxToast("Adhésion Sauvegardée");
        this.showEditor = false;
        this.activeAdhesion = this.resetactiveAdhesion();
        this.$emit("adhesionschange", true);
      } catch (error) {
        if (error.response.status === 400 || error.response.status === 404) {
          this.launchEpicmaxToast(error.response.data);
        } else {
          this.launchEpicmaxToast("Erreur lors de la sauvegarde de l'adhésion");
        }
      }
    },
    closeModal() {
      this.activeAdhesion = this.resetactiveAdhesion();
      this.adhesionsList.forEach(element => {
        element.mapa = element.initMapa;
      });
      this.showEditor = false;
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    }
  },
  watch: {
    renouvellement_fin(newdate) {
      // weird moment behavior with isBefore.
      if (
        newdate &&
        moment(newdate, "DD-MM-YYYY").isBefore(moment()) &&
        newdate !== moment().format("DD-MM-YYYY") &&
        this.renouvellement_fin !== this.renouvellement_fin_back
      ) {
        this.renouvellement_fin = null;
        this.launchEpicmaxToast(
          "La date de fin de renouvellement ne peut pas être avant la date du jour"
        );
      }
    },
    activeAdhesion: {
      deep: true,
      handler(newValue, oldValue) {
        this.activeAdhesion.date_fin = this.addYear(newValue.date_adhesion);
        if (newValue.selectPaiement.id === 7) {
          this.activeAdhesion.montant = 0;
        }
      }
    },
    identreprise(newid) {
      if (newid) {
        this.loadAdhesion(newid);
      } else {
      }
    }
  }
};
</script>

<style lang="scss">
.offset-delete {
  position: relative;
  top: -1em;
}

.container-comments {
  overflow: auto;
  overflow-x: hidden;
}
.clickable {
  display: flex;
  :hover {
    background-color: $light-gray3;
    cursor: pointer;
  }
}
.fullwidth {
  width: 95%;
}
.row-separator {
  width: 100%;
  border-color: #babfc2;
  border-width: 1px;
  border-bottom-style: solid;
}
.warning--text {
  color: red;
}

.text--mapa {
  position: relative;
  top: -1.5em;
  left: 4em;
}
</style>
